import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import styled from "../../styled-components";
import { space, position, flex, textAlign, color, border, layout } from "styled-system";
export var Box = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), space, layout, position, flex, textAlign, color, border);